import React from 'react';

import uiCatalogSections from './examples';

const pageStyle: React.CSSProperties = {
    background: '#f5f7fb',
    color: '#1f2933',
    minHeight: '100vh',
    padding: 32,
};

const sectionStyle: React.CSSProperties = {
    marginTop: 32,
};

const gridStyle: React.CSSProperties = {
    display: 'grid',
    gap: 16,
    gridTemplateColumns: 'repeat(auto-fit, minmax(420px, 1fr))',
};

const exampleStyle: React.CSSProperties = {
    background: '#ffffff',
    border: '1px solid #d9e2ec',
    borderRadius: 8,
    boxShadow: '0 1px 2px rgba(15, 23, 42, 0.08)',
    padding: 20,
};

const comparisonGridStyle: React.CSSProperties = {
    borderTop: '1px solid #e5eaf0',
    display: 'grid',
    gap: 16,
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    marginTop: 16,
    paddingTop: 16,
};

const previewStyle: React.CSSProperties = {
    background: '#f8fafc',
    border: '1px solid #e5eaf0',
    borderRadius: 6,
    minHeight: 88,
    padding: 16,
};

const labelStyle: React.CSSProperties = {
    color: '#52606d',
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: 0.8,
    marginBottom: 12,
    textTransform: 'uppercase',
};

const UiCatalog = () => (
    <main data-test="ui-catalog" style={pageStyle}>
        <header>
            <p style={{ fontSize: 12, fontWeight: 700, letterSpacing: 1.2 }}>
                DEVELOPMENT ONLY
            </p>
            <h1>@app/ui visual catalog</h1>
            <p>
                Local visual parity surface for valid portable component
                examples. New `@app/ui` primitives render beside the raw AntD
                components they replace so reviewers can compare visual output.
                Do/don&apos;t guidance stays in Markdown catalog files.
            </p>
        </header>

        {uiCatalogSections.map(section => (
            <section key={section.name} style={sectionStyle}>
                <h2>{section.name}</h2>
                <p>{section.description}</p>
                <div style={gridStyle}>
                    {section.examples.map(
                        ({ name, description, Example, ReferenceExample }) => (
                            <article
                                data-test="ui-catalog-example"
                                key={`${section.name}-${name}`}
                                style={exampleStyle}
                            >
                                <h3>{name}</h3>
                                <p>{description}</p>
                                <div style={comparisonGridStyle}>
                                    <div style={previewStyle}>
                                        <div style={labelStyle}>
                                            New @app/ui
                                        </div>
                                        <Example />
                                    </div>
                                    <div style={previewStyle}>
                                        <div style={labelStyle}>
                                            {section.referenceLabel ??
                                                'Raw AntD reference'}
                                        </div>
                                        {ReferenceExample ? (
                                            <ReferenceExample />
                                        ) : null}
                                    </div>
                                </div>
                            </article>
                        ),
                    )}
                </div>
            </section>
        ))}
    </main>
);

export default UiCatalog;
